import { FC } from 'react';
import { UseFormRegister, FieldError } from 'react-hook-form';
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  SimpleGrid,
} from '@chakra-ui/react';

import { CustomerFormFields } from 'page/CustomerPage/types/customerFormField';
import { EnvironmentFormBase } from '../../FormBases';

type Props = {
  register: UseFormRegister<CustomerFormFields>;
  error: FieldError | undefined;
};

/**
 * 編集モーダル用の環境（GCP プロジェクト名）フォームです。
 */
export const EnvironmentForm: FC<Props> = ({ register, error }) => (
  <FormControl isRequired isInvalid={Boolean(error)}>
    <SimpleGrid templateColumns="1fr 2fr">
      <FormLabel>GCP プロジェクト名</FormLabel>
      <EnvironmentFormBase register={register} />
      <FormErrorMessage>{error && error.message}</FormErrorMessage>
    </SimpleGrid>
  </FormControl>
);
